import { timeFrameMapping } from './widget-constants';

export const nsmWidgets = [
  {
    name: 'Top Applications',
    w: 6,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    groupByOptions: [
      'sessions',
      'data sent',
      'data received',
      'virus',
      'intrusion',
      'spyware',
      'total data transferred',
      'total blocked',
    ],
    groupBy: 'sessions',
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/1',
    drillDownUrl: '/m/analytics/reports/summary/essential/91',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/1',
  },
  {
    name: 'Top Users',
    w: 3,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    isPercentage: true,
    groupByOptions: [
      'sessions',
      'data sent',
      'data received',
      'virus',
      'intrusion',
      'spyware',
      'access rule blocked',
      'threat blocked',
      'geoIP blocked',
      'botnet blocked',
      'total data transferred',
      'total blocked',
    ],
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/2',
    drillDownUrl: '/m/analytics/reports/summary/essential/92',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/2',
    groupBy: 'sessions',
  },
  {
    name: 'Top Addresses',
    w: 3,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    groupByOptions: [
      'sessions',
      'data sent',
      'data received',
    ],
    groupBy: 'sessions',
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/3',
    drillDownUrl: '/m/analytics/reports/summary/essential/93',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/3',
  },
  {
    name: 'Top Web Categories',
    w: 3,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/9',
    drillDownUrl: '/m/analytics/reports/summary/essential/99',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/9',
  },
  {
    name: 'Observed Threats',
    w: 3,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    isPercentage: false,
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    refreshRate: 60,
    disableTimeFrameDropdown: false,
    drillDownUrl: [
      '/m/analytics/reports/summary/94',
      '/m/analytics/reports/summary/95',
      '/m/analytics/reports/summary/96',
      '/m/mgmt/monitor/details/essential/1',
    ],
    advancedDrillDownUrl: '/m/analytics/reports/summary/advance/21',
  },
  {
    name: 'Top Intrusions',
    w: 3,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/5',
    drillDownUrl: '/m/analytics/reports/summary/essential/95',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/5',
  },
  {
    name: 'Top Viruses',
    w: 3,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/4',
    drillDownUrl: '/m/analytics/reports/summary/essential/94',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/4',
  },

  {
    name: 'Top Spyware',
    w: 3,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    isPercentage: false,
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/6',
    drillDownUrl : '/m/analytics/reports/summary/essential/96',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/6',
  },

  {
    name: 'Top Botnet',
    w: 3,
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    disableTimeFrameDropdown: false,
    drillDownUrl: '/m/mgmt/monitor/details/essential/8',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/11',
  },

  {
    name: 'Threat Insights',
    w: 3,
    endpoint: '/reportlite/reports',
    component: 'verticalStatus',
    preview: 'verticalStatusPreview',
    timeFrameOptions: [],
    disableTimeFrameDropdown: true,
    drillDownUrl: [
      '/m/dashboard/overview/status/device',
      '/m/nsm/status/nsm-event-logs',
    ],
  },

  {
    name: 'Devices Summary by Location',
    w: 6,
    endpoint: '/devices/locations/summary',
    component: 'map',
    preview: 'mapPreview',
    timeFrameOptions: [],
    disableTimeFrameDropdown: true,
    drillDownUrl: '/m/nsm/devices/device-management',
  },

  {
    name: 'Devices Summary',
    w: 3,
    endpoint: '/devices/locations/summary',
    component: 'horizontalBarChart',
    preview: 'horizontalBarChartPreview',
    timeFrameOptions: [],
    disableTimeFrameDropdown: true,
    drillDownUrl: '/m/nsm/devices/device-management',
  },
];
